<ion-content>
  <div class="imgDiv">
    <img src="assets/imgs/logo.svg" alt="Fyra">
  </div>
  <div class="container">
    <ion-item>
      <ion-avatar *ngIf="this.userData?.firstPic !== ''">
        <img alt="" [src]=this.userData?.firstPic />
      </ion-avatar>
      <ion-label>
        <h2>{{this.userData?.firstName}}</h2>
      </ion-label>
    </ion-item>
    <div class="text-invited">
      {{'thankYoutForSigning' | translate}}
    </div>
    <div class="text-explanation">
      {{'forABetterExperienceDownloadTheApp' | translate}}
    </div>
    <div class="featureButtons">
      
      <ion-button class="defaultLogin"  expand="full" (click)="downloadApp()" shape="round" >
        {{'downloadApp' | translate}}
      </ion-button>
      
    </div>
  </div>
  <div class="closeAndContinue" (click)="closeReferral()">{{'closeAndContinue' | translate}}</div>
</ion-content>
